export { Tabs, TabsList, TabsTrigger, TabsContent } from "@pericles/framework-frontend";
